let ExtractionConst = {
  /*
      regex 'genes' for building regex date format strings
  */
  matchers: {
    shortYear: "(\\d{2})",
    year: "(1[0-9]\\d{2}|2[0-9]\\d{2})",
    month: "(\\d{1,2})",
    dispMonth: "(january|february|march|april|may|june|july|august|september|october|november|december|jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)",
    date: "(\\d{1,2})",
    hour: "(\\d{1,2})",
    min: "(\\d{2})",
    sec: "(\\d{2})",
    clock: "(pm)?",
    sep: "[\\/\\-\.]",
    gap: '.{1,2}',
    space: '\\s?',
    wordSpace: '\\D{1,25}'
  },
  /*
  recognized date formats, consumed as regex strings in `parseDate`
  */
  tests: [
    ['year'],
    ['dispMonth', ' ', 'year'],
    ['month', 'sep', 'date', 'sep', 'shortYear'],
    ['month', 'sep', 'date', 'sep', 'year'],
    ['dispMonth', ' ', 'date', 'gap', 'year'],
    ['hour', 'space', 'clock', 'wordSpace', 'dispMonth', ' ', 'date',
      ', ', 'year'
    ],
    ['hour', ':', 'min', 'space', 'clock', 'wordSpace', 'dispMonth',
      ' ', 'date', ', ', 'year'
    ],
    ['hour', ':', 'min', ':', 'sec', 'space', 'clock', 'wordSpace',
      'dispMonth',
      ' ', 'date', ', ', 'year'
    ],
    ['month', 'sep', 'date', 'sep', 'year', ' ', 'hour', 'space', 'clock'],
    ['month', 'sep', 'date', 'sep', 'year', ' ', 'hour', ':', 'min',
      'space',
      'clock'
    ],
    ['month', 'sep', 'date', 'sep', 'year', ' ', 'hour', ':', 'min',
      ':', 'sec', 'space', 'clock'
    ],
    ['dispMonth', ' ', 'date', ', ', 'year', 'wordSpace', 'hour', 'space',
      'clock'
    ],
    ['dispMonth', ' ', 'date', ', ', 'year', 'wordSpace', 'hour', ':',
      'min', 'space', 'clock'
    ],
    ['dispMonth', ' ', 'date', ', ', 'year', 'wordSpace', 'hour', ':',
      'min', ':', 'sec', 'space', 'clock'
    ],
  ],

}
export default angular.module('contants.extraction', [])
  .constant('ExtractionConst', ExtractionConst)
  .name;



// WEBPACK FOOTER //
// ./project/constants/extraction.js